import BaseHeading from '@tiptap/extension-heading';

import { lineSlot } from './line-slot';

export const Heading = BaseHeading.extend({
  addAttributes() {
    return {
      lineSlot,
      dataType: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-type'),
        renderHTML: (attributes: Record<string, any>) => {
          return {
            'data-type': attributes.dataType,
          };
        },
      },
      level: {
        default: 1,
        rendered: false,
        parseHTML: () => null,
      },
    };
  },
  addInputRules() {
    return [];
  },
});
